type Size = { width: number; height: number };

// The server (savePictures) stores the visitor photo at most 420px wide, cropped to the
// configured aspect ratio. The tallest one is 3:4 (420x560), so anything above that box is
// discarded on the server and only slows down the upload.
const PICTURE_MIN_BOX: Size = { width: 420, height: 560 };

// The server re-encodes the photo at quality 85, so sending it at 0.9 avoids visible
// generation loss.
export const PICTURE_JPEG_QUALITY = 0.9;

// The server (createPdfVisitNda) always draws the signature stretched into a 400x200pt box.
// 3px per point matches the signature canvas native height (300pt @2x = 600px), so the PDF
// keeps the same sharpness.
const SIGNATURE_MAX: Size = { width: 1200, height: 600 };

// Scales the photo down, keeping its aspect ratio, while still covering the box the server
// crops from. Returns null when it is already small enough.
export function getPictureTargetSize({ width, height }: Size): Size | null {
  const scale = Math.max(PICTURE_MIN_BOX.width / width, PICTURE_MIN_BOX.height / height);
  if (scale >= 1) return null;

  return { width: Math.ceil(width * scale), height: Math.ceil(height * scale) };
}

// The PDF stretches the signature to a fixed box anyway, so each axis can be capped on its
// own without changing how it looks. Returns null when it is already small enough.
export function getSignatureTargetSize({ width, height }: Size): Size | null {
  if (width <= SIGNATURE_MAX.width && height <= SIGNATURE_MAX.height) return null;

  return {
    width: Math.min(width, SIGNATURE_MAX.width),
    height: Math.min(height, SIGNATURE_MAX.height),
  };
}
